// pipelineSlice.ts
// @ts-nocheck
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import {  fetchEmailData, fetchEmailDataStatus, fetchPipelineDetails, updateLocationData } from '../../services/emailService';
import { ApiError, CreateEmailPayload, TeamsResponse, TeamsState, createTeamsPayload, updateTeamsPayload } from './emailType';
import { createLoationData } from '../../services/emailService';



export const fetchEmailList = createAsyncThunk<
  TeamsResponse,
  number,
  { rejectValue: string }
>(
  'base/fetchEmailList',
  async (baseId, { rejectWithValue }) => {
    try {
      if (baseId === undefined) {
        throw new Error('Base ID is undefined');
      }
      const response = await fetchEmailData(baseId);
      return response;
    } catch (err) {
      const error = err as Error;
      return rejectWithValue(error.message || 'Failed to fetch base data');
    }
  }
);


// fetch location by status
export const fetchEmailListStatus = createAsyncThunk<
  TeamsResponse,
  { baseId: number; status?: string },
  { rejectValue: string }
>(
  'base/fetchEmailListStatus',
  async ({ baseId, status }, { rejectWithValue }) => {
    try {
      const response = await fetchEmailDataStatus(baseId, status);
      return response;
    } catch (err) {
      const error = err as Error;
      return rejectWithValue(error.message || 'Failed to fetch base data');
    }
  }
);


// create teams 
export const createEmail = createAsyncThunk(
    'base/createEmail',
    async ({ payload, userId }: { payload: CreateEmailPayload; userId: number }, { rejectWithValue }) => {
        try {
            const response = await createLoationData(payload, userId);
            return response;
        } catch (err) {
            const error = err as ApiError;
            // Handling specific API error for duplicate emails
            if (error.response?.status === 409) {
                const customErrorMessage = error.response?.data?.error || 'Email already exists with the same base_id and question_title';
                return rejectWithValue(customErrorMessage);  // Return the custom error message for 409 conflict
            }

            // Handle other errors
            const errorMessage = error.response?.data?.message 
                || error.response?.data?.error 
                || error.message 
                || 'Failed to create email';
            return rejectWithValue(errorMessage);  // Return generic error message
        }
    }
);




// update teams
export const updateLocation = createAsyncThunk<TeamsResponse, { payload: updateTeamsPayload; userId: number, id: number },
  { rejectValue: string }
>(
  'base/updateLocation',
  async ({ payload, userId, id }, { rejectWithValue }) => {
    try {
      const response = await updateLocationData(userId, id, payload);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to invite member');
    }
  }
);

// pipeline details

export const fetchPipelineDetailsData = createAsyncThunk<
  TeamsResponse, 
  { baseId: number; userId: string }, 
  { rejectValue: string }
>(
  'base/fetchPipelineDetails',
  async ({ baseId, userId }, { rejectWithValue }) => {
    try {
      const response = await fetchPipelineDetails(baseId, userId);
      return response;  // Ensure this matches TeamsResponse type
    } catch (err) {
      const error = err as Error;
      return rejectWithValue(error.message || 'Failed to fetch pipeline details');
    }
  }
);


const initialState: TeamsState = {
  locationDetails: null,
  locationStatus: 'idle',
  locationStatusError: null,
  createTeamsStatus: 'idle',
  createTeamsError: null,
  createTeamsData: null,
  updateTeamsStatus: 'idle',
  updateTeamsError: null,
  updateTeamsData: null,
  deleteTeamsStatus: 'idle',
  deleteTeamsError: null,
  fetchTeamsByIdStatus: 'idle',
  fetchTeamsByIdError: null,
  fetchTeamsByIdData: null,
  baseMemberInviteStatus: 'idle',
  baseMemberInviteError: null,
  baseMemberInviteData: null,
  locationDetails1: null,
  locationStatus1: 'idle',
  locationStatusError1: null,
  // fetch pipeline details
  
  pipelineDetails: null,
  pipelineStatus: 'idle',
  pipelineStatusError: null,


};

const emailSlice = createSlice({
  name: 'email',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailList.pending, (state) => {
        state.locationStatus = 'loading';
      })
      .addCase(fetchEmailList.fulfilled, (state, action: PayloadAction<TeamsResponse>) => {
        state.locationStatus = 'succeeded';
        state.locationDetails = action.payload.data;
        // localStorage.setItem('basePiplineData', JSON.stringify(action.payload));
      })
      .addCase(fetchEmailList.rejected, (state, action) => {
        state.locationStatus = 'failed';
        state.locationStatusError = action.payload || 'Failed to fetch boards';
      })
      .addCase(createEmail.pending, (state) => {
        state.createTeamsStatus = 'loading';
      })
      .addCase(createEmail.fulfilled, (state, action: PayloadAction<TeamsResponse>) => {
        state.createTeamsStatus = 'succeeded';
        state.createTeamsData = action.payload;
      })
      .addCase(createEmail.rejected, (state, action) => {
        state.createTeamsStatus = 'failed';
        state.createTeamsError = action.payload || 'Failed to invite member';
      })
      .addCase(updateLocation.pending, (state) => {
        state.updateTeamsStatus = 'loading';
      })
      .addCase(updateLocation.fulfilled, (state, action: PayloadAction<TeamsResponse>) => {
        state.updateTeamsStatus = 'succeeded';
        state.updateTeamsData = action.payload;
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.updateTeamsStatus = 'failed';
        state.updateTeamsError = action.payload || 'Failed to invite member';
      })
      .addCase(fetchEmailListStatus.pending, (state) => {
        state.locationStatus1 = 'loading';
      })
      .addCase(fetchEmailListStatus.fulfilled, (state, action: PayloadAction<TeamsResponse>) => {
        state.locationStatus1 = 'succeeded';
        state.locationDetails1 = action.payload.data;
        // localStorage.setItem('basePiplineData', JSON.stringify(action.payload));
      })
      .addCase(fetchEmailListStatus.rejected, (state, action) => {
        state.locationStatus1 = 'failed';
        state.locationStatusError1 = action.payload || 'Failed to fetch boards';
      })
      .addCase(fetchPipelineDetailsData.pending, (state) => {
        state.pipelineStatus = 'loading';
      })
      .addCase(fetchPipelineDetailsData.fulfilled, (state, action: PayloadAction<TeamsResponse>) => {
        state.pipelineStatus = 'succeeded';
        state.pipelineDetails = action.payload.data;
        // localStorage.setItem('basePiplineData', JSON.stringify(action.payload));
      })
      .addCase(fetchPipelineDetailsData.rejected, (state, action) => {
        state.pipelineStatus = 'failed';
        state.pipelineStatusError = action.payload || 'Failed to fetch boards';
      })
      
  }
});


export default emailSlice.reducer;

